import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { useLocation, useSearchParams } from "react-router-dom";

import { useBlogArticleSelectors } from "../../store/blogArticle/blogArticle.selectors";
import { useContentSelectors } from "../../store/content/content.selectors";
import { useActiveLanguages } from "../../store/languages/language.selectors";

import {
  generateAlternateLinksForSEO,
  generateCanonicalLinkForSEO,
  generateFaqJsonLd,
  generateMetaTagsAndLinks,
} from "../../utils/helpers";

import { useFaq } from "../../hooks";
import useMetaDate from "../../hooks/use-meta-date";

const MetaDate = () => {
  const location = useLocation();
  const { languages } = useActiveLanguages();
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();

  const seo = useMetaDate();
  const { faqItems } = useFaq();
  const { data } = useBlogArticleSelectors();
  const { allCountry, html } = useContentSelectors();

  const country = searchParams.get("country");

  let seoCountryTitle = "";
  let seoCountryDescription = "";

  if (country) {
    const countryObject = allCountry.find(item => item.englishName === country);
    const postNameCountry = t("global.for") + countryObject?.name;

    if (seo?.countryInfo?.title) {
      seoCountryTitle = seo?.countryInfo?.title;
    }
    if (!seo?.countryInfo?.title) {
      seoCountryTitle = seo?.title + postNameCountry;
    }
    if (seo?.countryInfo?.description) {
      seoCountryDescription = seo?.countryInfo?.description;
    }
    if (!seo?.countryInfo?.description) {
      seoCountryDescription = seo?.description + postNameCountry;
    }
  }

  const articleTitle = data?.metaData?.title || "";
  const articleDescription = data?.metaData?.description || "";

  const title = seoCountryTitle || seo?.title || articleTitle;
  const description =
    seoCountryDescription || seo?.description || articleDescription;
  const language = seo?.language;
  const htmlDir = seo?.htmlDir;
  return (
    <Helmet>
      {generateMetaTagsAndLinks(title, description, language, htmlDir)}
      {generateAlternateLinksForSEO(languages, location)}
      {generateCanonicalLinkForSEO(location)}
      {faqItems?.length > 0 && generateFaqJsonLd(faqItems)}
      {html && <script type="application/ld+json">{`${html}`}</script>}
    </Helmet>
  );
};

export default MetaDate;
